<div class="row" *ngIf='readOnly'>
    <div class="col-sm-12 table-responsive no-border">
        <form [formGroup]="deviceForm" novalidate>
            <table class="table table-condensed">
                <tbody>
                    <tr>
                        <td class="col-sm-6 no-left-padding">
                            <table class="table table-inner table-condensed ">
                                <tbody>
                                    <tr>
                                        <th>Product SKU</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Product SKU')">
                                            <label controlName="productSKU"> </label> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-6 no-right-padding">
                          <table class="table table-inner table-condensed ">
                            <tbody>
                              <tr>
                                      <th>Company Device Batch Number </th>
                                      </tr>
                                  <tr>
                                    <td [ngClass]="isDefault('Company Device Batch Number')">
                                      <label controlName="batchNumber"></label>
                                    </td>
                                  </tr>
                                  </tbody>
                                  </table>
                                  </td>
                    </tr>
                    <tr>
                        <td class="col-sm-6 no-left-padding">
                            <table formArrayName="submissionChannelForm" class="table table-inner table-condensed ">
                                <tbody>
                                    <tr>
                                        <th>Applicable Submission Channel</th>
                                    </tr>
                                    <ng-container *ngIf="submissionChannelForm.controls.length; else emptyTemplate1field">
                                    <tr formGroupName="{{i}}"
                                        *ngFor="let sizeGroup of submissionChannelForm.controls; let i = index">
                                        <td [ngClass]="isDefault('Applicable Submission Channel')">
                                            <label controlName="channel"></label>
                                        </td>
                                    </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-6 no-right-padding">
                            <table class="table table-inner table-condensed ">
                                <tbody>
                                    <tr>
                                        <th>Company Device Tracking Number </th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Company Device Tracking Number')">
                                            <label controlName="trackingNumber"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                      <td class="col-sm-6 no-left-padding">
                        <table class="table table-inner table-condensed ">
                          <tbody>
                            <tr>
                              <th>Company Product Cross Reference DI</th>
                            </tr>
                            <tr>
                              <td [ngClass]="isDefault('Company Product Cross Reference DI')">
                                <label controlName="companyProductCrossReferenceDi"> </label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>
